import React, { useMemo, useState } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import styled, { css } from 'styled-components';
import useUsersStore from '../../../../../hooks/useUsersStore';
import { observer } from 'mobx-react';
import { Url } from '../../../../../common/constants/environment';
import { Link } from 'react-router-dom';
import champIcon from 'images/common-function/ic-champ.svg';

const MatchCheerCommentItem = observer(
  ({
    item,
    teams,
    setViewImage,
    setSelectedUser,
    setViewUserAction,
    loginUserId,
    basePathname,
    animate,
    onClickParent,
  }) => {
    const usersStore = useUsersStore();
    const {
      profile_image_path,
      content,
      user,
      create_at,
      image_path,
      ws,
      crime_type,
      nick_mark,
      type,
      message_type,
      differentGame,
      is_sports_analysis,
      parent_id,
      parent_mb_nick,
      parent_content,
      parent_image_path,
      isChamp,
      msg_point,
    } = item;

    const [viewBlind, setViewBlind] = useState(false);
    const formattedTime = moment(create_at).format('HH:mm');
    const isMe = useMemo(() => {
      return usersStore.me.mb_id === user.user_id;
    }, [usersStore.me.mb_id, user]);

    const chatText = useMemo(() => {
      if (user.is_admin) {
        if (user.home_away === 'HOME') {
          return `${teams.home.name} ${content}`;
        } else if (user.home_away === 'AWAY') {
          return `${teams.away.name} ${content}`;
        } else {
          return content;
        }
      } else {
        return content;
      }
    }, [content, user.home_away, user.is_admin, teams]);

    return (
      <>
        {!!parent_id && (
          <li
            id={item.id}
            className={clsx('item_comment_message')}
            onClick={() => {
              onClickParent(parent_id);
            }}
          >
            <span>{`@${parent_mb_nick}`}</span>
            <div className={'comment_content'}>
              {!!parent_image_path && (
                <img
                  src={
                    !!isChamp
                      ? `${Url.champThumb}${parent_image_path}?x=20&y=20`
                      : `${Url.thumb}normal/resize/100x100${parent_image_path}`
                  }
                />
              )}
              <p>{parent_content}</p>
            </div>
          </li>
        )}
        <li
          id={item.id}
          className={clsx(
            'item_message',
            isMe && 'me',
            ws && 'ws',
            type ? type : user.is_admin && 'relay',
            differentGame && 'different_game',
            animate && 'animate',
            !!isChamp && 'champ'
          )}
          onClick={() => {
            if (loginUserId === user.user_id || differentGame || !!isChamp) return;
            setViewUserAction(true);
            setSelectedUser(item);
          }}
        >
          <Link
            className='lnk_user'
            to={!!isChamp ? window.location.pathname : `/user/${user.user_id}`}
            onClick={(e) => e.stopPropagation()}
          >
            <span className={clsx('thumb', `lv${user.level}`)}>
              <img
                src={
                  !!isChamp
                    ? `${Url.champThumb}${profile_image_path}`
                    : user.is_admin
                    ? `/images/ic-cheer-${type ? type : 'caster'}.png`
                    : user.profile_img
                }
                onError={(event) => {
                  event.target.src = '/images/thumb_user_def.png';
                }}
              />
              {!user.is_admin && (
                <svg
                  className='border'
                  version='1.1'
                  id='Layer_1'
                  xmlns='http://www.w3.org/2000/svg'
                  xmlnsXlink='http://www.w3.org/1999/xlink'
                  x='0px'
                  y='0px'
                  viewBox='0 0 36 36'
                  enableBackground='new 0 0 36 36'
                  xmlSpace='preserve'
                >
                  <path d='M18,2c10.9,0,16,5.1,16,16c0,10.9-5.1,16-16,16C7.1,34,2,28.9,2,18C2,7.1,7.1,2,18,2 M18,0C6,0,0,6,0,18c0,12,6,18,18,18c12,0,18-6,18-18C36,6,30,0,18,0L18,0z' />
                </svg>
              )}
              <em className={clsx('mark', nick_mark)} />
            </span>
          </Link>
          {image_path ? (
            <div className={clsx('message_balloon', !viewBlind && crime_type)}>
              <div>
                <span className={'message_time'}>{formattedTime}</span>
                {is_sports_analysis && <span className={'analysis'}>[분석가]</span>}
                {!!isChamp && <img className={'icon_champ'} src={champIcon} />}
                {!user.is_admin && <span className='name'>{user.nick}</span>}
                {differentGame && <DifferentGame item={item} />}
              </div>
              {crime_type === 'b' && !viewBlind ? (
                <span
                  className={clsx('message', crime_type)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setViewBlind(!viewBlind);
                  }}
                >
                  *블라인드 처리된 채팅입니다.
                </span>
              ) : (
                <div>
                  <img
                    src={
                      !!isChamp ? `${Url.champThumb}${image_path}` : `${Url.thumb}normal/resize/100x100${image_path}`
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      setViewImage(
                        !!isChamp ? `${Url.champThumb}${image_path}` : `${Url.thumb}normal/resize/origin${image_path}`
                      );
                    }}
                  />
                  <span className={clsx('message', crime_type, nick_mark)}>{chatText}</span>
                </div>
              )}
            </div>
          ) : (
            <div className='message_balloon'>
              <span className={'message_time'}>{formattedTime}</span>
              {!!isChamp && <img className={'icon_champ'} src={champIcon} />}
              {is_sports_analysis && <span className={'analysis'}>[분석가]</span>}
              {!user.is_admin && <span className='name'>{user.nick}</span>}
              {differentGame && (
                <>
                  <DifferentGame item={item} />
                  <br />
                </>
              )}
              <span
                className={clsx('message', crime_type, nick_mark)}
                onClick={(e) => {
                  if (crime_type === 'b' && !viewBlind) {
                    e.stopPropagation();
                    setViewBlind(!viewBlind);
                  }
                }}
              >
                {crime_type === 'b' && !viewBlind
                  ? '*블라인드 처리된 채팅입니다.'
                  : chatText &&
                    chatText.split(' ').map((text, key) => {
                      if (text.indexOf('▲') !== -1) {
                        return <em className={'up'} key={key}>{`${text.replace('▲', '')} `}</em>;
                      } else if (text.indexOf('▼') !== -1) {
                        return <em className={'down'} key={key}>{`${text.replace('▼', '')} `}</em>;
                      } else {
                        return `${text} `;
                      }
                    })}
              </span>
              {(message_type === 'ODDS' || message_type === 'LINEUP' || message_type === 'ANALYSIS') &&
                !differentGame && <InfoLink item={item} basePathname={basePathname} />}
            </div>
          )}
        </li>
        {msg_point?.trim() && <MessagePoint>{msg_point}</MessagePoint>}
      </>
    );
  }
);

const DifferentGame = ({ item }) => {
  return (
    <a
      className={'game_score'}
      href={`/match/${item.sports_name === 'star' ? 'starcraft' : item.sports_name}/${item.game_id}/cheer`}
      onClick={(e) => e.stopPropagation()}
    >{`${item.home_name} ${item.home_score} - ${item.away_score} ${item.away_name}`}</a>
  );
};

const InfoLink = ({ item, basePathname }) => {
  return (
    <Link to={`${basePathname}/${item.message_type.toLowerCase()}`} onClick={(e) => e.stopPropagation()}>
      확인하기
    </Link>
  );
};

export const MessagePoint = styled.div`
  font-family: Tahoma, -apple-system, SF Pro Display, Helvetica Neue, sans-serif;
  text-align: center;
  font-size: 12px;
  color: #c84056;
  width: 100%;
  font-weight: 700;
  margin-top: -5px;
`;

export default MatchCheerCommentItem;
